import axios from 'axios'
import {Toast} from 'vant';

import Vue from 'vue'

const service = axios.create({
  // baseURL: process.env.VUE_APP_SERVER_URL + process.env.VUE_APP_BASE_API,
  timeout: 7000
})

// 添加 request 拦截器
/* eslint-disable */
service.interceptors.request.use((config) => {
  return config;
}, (error) => {
  return Promise.reject(error);
})

service.interceptors.response.use((response) => {
  return response;
}, (error) => {
  let errorTitle = '未知错误';
  let errorMessage = null;

  if (error.code === 'ECONNABORTED') {
    errorMessage = '连接超时！';
  } else if (error.response) {
    errorTitle = `${error.response.status} 错误`;

    const data = error.response.data;
    if (data && data.error) {
      if (data.error.message) {
        errorMessage = data.error.message;
      }
    }

    if (!errorMessage) {
      switch (error.response.status) {
        case 400:
          errorMessage = '发出的请求有错误，服务器没有进行新建或修改数据的操作。';
          break;
        case 401:
          errorMessage = '用户没有权限（令牌、用户名、密码错误）。';
          break;
        case 403:
          // errorMessage = '用户得到授权，但是访问是被禁止的。';
          errorMessage = `${error.config.url} 访问被禁止。`;
          break;
        case 404:
          errorMessage = '发出的请求针对的是不存在的记录，服务器没有进行操作。';
          break;
        case 500:
          errorMessage = '服务器发生错误，请检查服务器。';
          break;
        case 502:
          errorMessage = '网关错误。';
          break;
        case 503:
          errorMessage = '服务不可用，服务器暂时过载或维护。';
          break;
        case 504:
          errorMessage = '网关超时。';
          break;
      }
    }
  }

  Toast.fail({
    message: errorMessage,
    duration: 5 * 1000
  })
  return Promise.reject(error)
})

export default service;
